import { ImageCarousel } from "atoms/ImageCarousel/ImageCarousel";

export interface RetailProductImageSectionProps {
  imageUris: string[];
  productName: string;
}

export const RetailProductImageSection = ({
  imageUris,
  productName,
}: RetailProductImageSectionProps) => {
  const slides = imageUris.map((uri, index) => ({
    src: uri,
    alt: `${productName} - Image ${index + 1}`,
  }));

  return (
    <div className="flex flex-col items-center">
      <ImageCarousel slides={slides} productName={productName} />
    </div>
  );
};
